module.exports = __webpack_public_path__ + "img/vegetable-brussels-sprouts-350x184.4cd6981f.jpg";